import React from 'react';
import {
  useWizardService,
  getIsLastStep,
} from '@bingads-webui-react/wizard';
import { BasicStepFooter } from '@bingads-webui-react/wizard-ui-library';

export const AppAdsStepFooter = () => {
  const { state } = useWizardService();
  const isLastStep = getIsLastStep(state);

  return (
    <BasicStepFooter
      nextButtonText={isLastStep ? _TL_('Save') : _TL_('Save & go to next step')}
      hideCancelButton={isLastStep}
    />
  );
};

